/* prettier-ignore */

import { Component, inject } from '@angular/core';
import Swal from'sweetalert2';
import { TranslationService } from 'src/app/services/translation.service';
import { INFORMER_MODE_STORAGE_KEY, INFORMER_REGISTER_STORAGE_KEY, INFORMER_RESOURCES_STORAGE_KEY, INFORMER_ROUTE_ITEMS_STORAGE_KEY, INFORMER_ROUTE_REGISTER_STORAGE_KEY } from 'src/app/interfaces';

@Component({
  selector: 'header-tech-logout',
  templateUrl: './tech-exit.component.html',
  styleUrl: './tech-exit.component.scss',
})

export class HeaderTechExitComponent {
  private _translationService = inject(TranslationService);

    constructor(
    ) {}

    exitTechMode(){
        Swal.fire({
            title: this._translationService.instant(`¿Quieres salir del modo edición?`),
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: "#ff0000",
            cancelButtonColor: "#000000",
            confirmButtonText: this._translationService.instant("Cerrar sesión"),
            cancelButtonText: this._translationService.instant(`Cancelar`),
            reverseButtons: true,
            scrollbarPadding: false
        }).then((result) => {
            if (result.isConfirmed){
                // HRS-2990: se limpian las claves del modo — la nueva, la heredada,
                // el registro elegido y los recursos del correo — o al recargar
                // volvería a entrar en modo técnico con el trabajo a medias.
                localStorage.removeItem(INFORMER_MODE_STORAGE_KEY);
                localStorage.removeItem('techMode');
                localStorage.removeItem(INFORMER_REGISTER_STORAGE_KEY);
                localStorage.removeItem(INFORMER_RESOURCES_STORAGE_KEY);
                localStorage.removeItem(INFORMER_ROUTE_ITEMS_STORAGE_KEY);
                localStorage.removeItem(INFORMER_ROUTE_REGISTER_STORAGE_KEY);
                location.reload();
            }
        });
    }

}